import React from "react";
import Typography from "../../../Typography";
import { BaseDialogContent } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function DialogContent(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/_jsx(BaseDialogContent, {
    children: content && typeof content === "string" ? /*#__PURE__*/_jsx(Typography, {
      children: content
    }) : content
  });
}
export default DialogContent;